import {
  getServicePaths,
  LEGACY_PUBLIC_PATH_ALIASES,
  listRegistryServiceIds,
} from '@frontend/config/serviceUrlRegistry';

/**
 * True when a dashboard href should open outside the portal SPA in a new tab.
 * Prefixes come from the redirect registry public paths (not hardcoded service names).
 */
export function isExternalServiceHref(href: string): boolean {
  if (!href || href.startsWith('#')) return false;
  if (href.startsWith('http://') || href.startsWith('https://')) return true;
  const path = href.startsWith('/') ? href : `/${href}`;
  for (const id of listRegistryServiceIds()) {
    if (id === 'portal') continue;
    const pub = getServicePaths(id).public;
    if (!pub || pub === '/') continue;
    if (path === pub || path.startsWith(`${pub}/`) || path.startsWith(`${pub}?`) || path.startsWith(`${pub}#`)) {
      return true;
    }
  }
  for (const alias of LEGACY_PUBLIC_PATH_ALIASES) {
    if (path === alias || path.startsWith(`${alias}/`)) return true;
  }
  return false;
}

export const externalLinkProps = {
  target: '_blank' as const,
  rel: 'noopener noreferrer' as const,
};
